<div *ngIf="!loading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="form">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Cargos</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="col-2" title="Cargo" appearance="outline">
					<mat-label>Cargo</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cargo"
						formControlName="name"
						id="spn-{{ inputId }}"
						(focus)="showHint = true"
						(blur)="showHint = false"
					/>
					<mat-hint align="start" *ngIf="showHint">
						Ex.: Representante Comercial.
					</mat-hint>
					<mat-error *ngIf="form.get('name')?.hasError('required')">
						O nome do cargo é obrigatório, ex.: recepcionista
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Salário mínimo"
					appearance="outline"
				>
					<mat-label>Salário mínimo (opcional)</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Salário mínimo (opcional)"
						formControlName="min_wage"
						id="slw-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field class="col-1 dyn mob-va" appearance="outline">
					<mat-label>Salário máximo (opcional)</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Salário máximo (opcional)"
						formControlName="max_wage"
						id="shw-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Estado"
					appearance="outline"
				>
					<mat-label>Estado (opcional)</mat-label>
					<mat-select formControlName="state">
						<mat-option [value]="null" (click)="onUFChange(-1)">
							Estado (opcional)
						</mat-option>
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUFChange(s.id)"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field
					class="col-1 dyn mob-va"
					title="Cidade"
					appearance="outline"
				>
					<mat-label>Cidade (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cidade (opcional)"
						formControlName="city"
						id="sxx-{{ inputId }}"
						*ngIf="!auxStateForm"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm">
						<mat-option [value]="null">Cidade (opcional)</mat-option>
						<mat-option *ngFor="let city of cities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Benefícios de saúde</span>
			</div>
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs lh-xs gray">
					Benefícios de saúde que esse cargo tem direito
				</span>
			</div>
			<ng-container *ngFor="let hb of health; let hbIdx = index">
				<div class="separator" *ngIf="hbIdx > 0"></div>
				<div class="d-f line">
					<mat-form-field
						class="c-p col-2"
						title="Selecionar benefício"
						appearance="outline"
						(click)="openBaseHealthBenefitModal(hbIdx)"
					>
						<mat-label>Selecionar benefício</mat-label>
						<input
							type="text"
							matInput
							class="c-p"
							placeholder="Selecionar benefício"
							id="sfa-{{ inputId }}"
							[value]="hb.benefit_name"
							(focus)="hpick.focus()"
						/>
						<button matSuffix mat-icon-button aria-label="Open benefits dialog">
							<mat-icon>arrow_drop_down</mat-icon>
						</button>
					</mat-form-field>
					<mat-form-field
						class="ml-xxxs mr-xxxs col-1 dyn mob-va"
						title="Permite upgrade"
						appearance="outline"
					>
						<mat-label>Permite upgrade</mat-label>
						<mat-select
							[disabled]="!hb.benefit_id.length"
							[(value)]="hb.allow_upgrade"
							(valueChange)="onAllowUpgradeChange(hbIdx)"
						>
							<mat-option *ngFor="let ans of ansOptions" [value]="ans.value">
								{{ ans.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div
					class="d-f mt-xxs line mini"
					*ngFor="let hu of hb.upgrades; let huIdx = index"
				>
					<mat-form-field
						class="c-p mr-xxxs col-2 mini"
						title="Benefício de upgrade"
						appearance="outline"
						(click)="
							openUpgradeBenefitModal(
								huIdx,
								hbIdx,
								hb.benefit_id,
								hb.benefit_partner
							)
						"
					>
						<mat-label>Benefício de upgrade</mat-label>
						<input
							type="text"
							matInput
							class="c-p"
							placeholder="Benefício de upgrade"
							id="sfa-{{ inputId }}"
							[value]="hu.benefit_name"
							(focus)="hpick.focus()"
						/>
						<button matSuffix mat-icon-button aria-label="Open benefits dialog">
							<mat-icon>arrow_drop_down</mat-icon>
						</button>
					</mat-form-field>
					<div
						class="d-f jc-c ai-c mr-xxxs squared {{
							hb.upgrades.length > 1 ? 'c-p' : ''
						}}"
						(click)="
							hb.upgrades.length > 1 ? onRemoveUpgrade(hbIdx, huIdx) : null
						"
					>
						<mat-icon
							[svgIcon]="
								hb.upgrades.length > 1 ? 'sanus-trash-blue' : 'sanus-trash-gray'
							"
						></mat-icon>
					</div>
					<div
						class="d-f jc-c ai-c squared right {{ hu.benefit_id ? 'c-p' : '' }}"
						(click)="hu.benefit_id ? onAddUpgrade(hbIdx) : null"
					>
						<mat-icon
							[svgIcon]="hu.benefit_id ? 'sanus-add-blue' : 'sanus-add-gray'"
						></mat-icon>
					</div>
				</div>
			</ng-container>
			<input #hpick type="text" class="picker" />
			<div class="mb-xxs mob-va">
				<button
					mat-flat-button
					color="primary"
					[disabled]="
						health.length > 9 || !health[health.length - 1].benefit_id.length
					"
					(click)="onAddBase()"
				>
					Adicionar outro benefício
				</button>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Benefícios dentais</span>
			</div>
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs lh-xs gray">
					Benefícios dentais que esse cargo tem direito
				</span>
			</div>
			<ng-container *ngFor="let db of dental; let dbIdx = index">
				<div class="separator" *ngIf="dbIdx > 0"></div>
				<div class="d-f mt-xxs line">
					<mat-form-field
						class="c-p col-2"
						title="Selecionar benefício"
						appearance="outline"
						(click)="openBaseDentalBenefitModal(dbIdx)"
					>
						<mat-label>Selecionar benefício</mat-label>
						<input
							type="text"
							matInput
							class="c-p"
							placeholder="Selecionar benefício"
							id="sfb-{{ inputId }}"
							[value]="db.benefit_name"
							(focus)="dpick.focus()"
						/>
						<button matSuffix mat-icon-button aria-label="Open benefits dialog">
							<mat-icon>arrow_drop_down</mat-icon>
						</button>
					</mat-form-field>
					<mat-form-field
						class="ml-xxxs mr-xxxs col-1 dyn mob-va"
						title="Permite upgrade"
						appearance="outline"
					>
						<mat-label>Permite upgrade</mat-label>
						<mat-select
							[disabled]="!db.benefit_id.length"
							[(value)]="db.allow_upgrade"
							(valueChange)="onAllowUpgradeChange(dbIdx, 'dental')"
						>
							<mat-option *ngFor="let ans of ansOptions" [value]="ans.value">
								{{ ans.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div
					class="d-f mt-xxs line mini"
					*ngFor="let du of db.upgrades; let duIdx = index"
				>
					<mat-form-field
						class="c-p mr-xxxs col-2 mini"
						title="Benefício de upgrade"
						appearance="outline"
						(click)="
							openUpgradeBenefitModal(
								duIdx,
								dbIdx,
								db.benefit_id,
								db.benefit_partner,
								'dental'
							)
						"
					>
						<mat-label>Benefício de upgrade</mat-label>
						<input
							type="text"
							matInput
							class="c-p"
							placeholder="Benefício de upgrade"
							id="sfa-{{ inputId }}"
							[value]="du.benefit_name"
							(focus)="dpick.focus()"
						/>
						<button matSuffix mat-icon-button aria-label="Open benefits dialog">
							<mat-icon>arrow_drop_down</mat-icon>
						</button>
					</mat-form-field>
					<div
						class="d-f jc-c ai-c mr-xxxs squared {{
							db.upgrades.length > 1 ? 'c-p' : ''
						}}"
						(click)="
							db.upgrades.length > 1
								? onRemoveUpgrade(dbIdx, duIdx, 'dental')
								: null
						"
					>
						<mat-icon
							[svgIcon]="
								db.upgrades.length > 1 ? 'sanus-trash-blue' : 'sanus-trash-gray'
							"
						></mat-icon>
					</div>
					<div
						class="d-f jc-c ai-c squared right {{ du.benefit_id ? 'c-p' : '' }}"
						(click)="du.benefit_id ? onAddUpgrade(dbIdx, 'dental') : null"
					>
						<mat-icon
							[svgIcon]="du.benefit_id ? 'sanus-add-blue' : 'sanus-add-gray'"
						></mat-icon>
					</div>
				</div>
			</ng-container>
			<input #dpick type="text" class="picker" />
			<div class="mb-xxs mob-va">
				<button
					mat-flat-button
					color="primary"
					[disabled]="
						dental.length > 9 || !dental[dental.length - 1].benefit_id.length
					"
					(click)="onAddBase('dental')"
				>
					Adicionar outro benefício
				</button>
			</div>
		</div>
		<div class="mb-xxxs br-md card">
			<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
				<div class="d-f ai-c mb-xxs">
					<span class="fs-xs fw-bold lh-xs to-ellipsis">
						Benefícios Conjugados
					</span>
				</div>
				<div class="d-f ai-c mb-xxs">
					<span class="fs-xs lh-xs gray">
						Benefícios conjugados que esse cargo tem direito
					</span>
				</div>
				<ng-container *ngFor="let cb of conjugated; let cbIdx = index">
					<div class="separator" *ngIf="cbIdx > 0"></div>
					<div class="d-f line">
						<mat-form-field
							class="c-p col-2"
							title="Selecionar benefício"
							appearance="outline"
							(click)="openBaseConjugatedBenefitModal(cbIdx)"
						>
							<mat-label>Selecionar benefício</mat-label>
							<input
								type="text"
								matInput
								class="c-p"
								placeholder="Selecionar benefício"
								id="sfc-{{ inputId }}-{{ cbIdx }}"
								[value]="cb.benefit_name"
								(focus)="cpick.focus()"
							/>
							<button
								matSuffix
								mat-icon-button
								aria-label="Open benefits dialog"
							>
								<mat-icon>arrow_drop_down</mat-icon>
							</button>
						</mat-form-field>
						<mat-form-field
							class="ml-xxxs mr-xxxs col-1 dyn mob-va"
							title="Permite upgrade"
							appearance="outline"
						>
							<mat-label>Permite upgrade</mat-label>
							<mat-select
								[disabled]="!cb.benefit_id.length"
								[(value)]="cb.allow_upgrade"
								(valueChange)="onAllowUpgradeChange(cbIdx, 'conjugated')"
							>
								<mat-option *ngFor="let ans of ansOptions" [value]="ans.value">
									{{ ans.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div
						class="d-f mt-xxs line mini"
						*ngFor="let cu of cb.upgrades; let cuIdx = index"
					>
						<mat-form-field
							class="c-p mr-xxxs col-2 mini"
							title="Benefício de upgrade"
							appearance="outline"
							(click)="
								openUpgradeBenefitModal(
									cuIdx,
									cbIdx,
									cb.benefit_id,
									cb.benefit_partner,
									'conjugated'
								)
							"
						>
							<mat-label>Benefício de upgrade</mat-label>
							<input
								type="text"
								matInput
								class="c-p"
								placeholder="Benefício de upgrade"
								id="sfu-{{ inputId }}-{{ cbIdx }}-{{ cuIdx }}"
								[value]="cu.benefit_name"
								(focus)="cpick.focus()"
							/>
							<button
								matSuffix
								mat-icon-button
								aria-label="Open benefits dialog"
							>
								<mat-icon>arrow_drop_down</mat-icon>
							</button>
						</mat-form-field>
						<div
							class="d-f jc-c ai-c mr-xxxs squared {{
								cb.upgrades.length > 1 ? 'c-p' : ''
							}}"
							(click)="
								cb.upgrades.length > 1
									? onRemoveUpgrade(cbIdx, cuIdx, 'conjugated')
									: null
							"
						>
							<mat-icon
								[svgIcon]="
									cb.upgrades.length > 1
										? 'sanus-trash-blue'
										: 'sanus-trash-gray'
								"
							></mat-icon>
						</div>
						<div
							class="d-f jc-c ai-c squared right {{
								cu.benefit_id ? 'c-p' : ''
							}}"
							(click)="cu.benefit_id ? onAddUpgrade(cbIdx, 'conjugated') : null"
						>
							<mat-icon
								[svgIcon]="cu.benefit_id ? 'sanus-add-blue' : 'sanus-add-gray'"
							></mat-icon>
						</div>
					</div>
				</ng-container>
				<input #cpick type="text" class="picker" />
				<div class="mb-xxs mob-va">
					<button
						mat-flat-button
						color="primary"
						[disabled]="
							conjugated.length > 9 ||
							!conjugated[conjugated.length - 1].benefit_id.length
						"
						(click)="onAddBase('conjugated')"
					>
						Adicionar outro benefício
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			class="margin-right-16"
			mat-stroked-button
			color="primary"
			routerLink="../"
		>
			Cancelar
		</button>
		<button
			mat-flat-button
			color="primary"
			[disabled]="shouldDisableSaveBtn()"
			(click)="onSubmit()"
		>
			Salvar cargos
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="loading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
